import { Components, Theme } from "@mui/material/styles";

export const MuiSvgIcon: Components<Theme>["MuiSvgIcon"] = {
    defaultProps: {
        fontSize: "inherit",
    },
    styleOverrides: {
        root: {
            display: "inline-block",
            verticalAlign: "middle",
        },
    },
};
